import { getBonus } from './getBonus.js';
const DEFAULT_BONUS_CALCULATOR_PARAMS = {
    minSumTravel: 6000,
    maxSumTravel: 200000,
    minSumOther: 6000,
    maxSumOther: 200000,
    maxBonus: 5000,
    prefMonthsNum: 2,
    prefTravelBonusRate: 0.015,
    prefRestBonusRate: 0.01,
    travelBonusRate: 0.015,
    restBonusRate: 0.01,
};
export const getBonusCalculatorParams = (userInputParams, calcSource) => {
    const { travelExpenseValue, restExpenseValue } = userInputParams;
    const [monthBonus, yearBonus] = getBonus(calcSource || DEFAULT_BONUS_CALCULATOR_PARAMS, travelExpenseValue, restExpenseValue);
    return {
        ...calcSource,
        ...userInputParams,
        monthBonus,
        yearBonus,
    };
};
//# sourceMappingURL=getBonusCalculatorParams.js.map